import { alphabet } from '../components/types';

const getAlphabetList = (availableLetters: string[]) =>
    alphabet.map(letter => ({
        letter,
        disabled: !availableLetters.includes(letter),
    }));
export default getAlphabetList;
